import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl =
  '/vote/2020project/2020shangyou_community/controller.php?enews=';

export const getBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};
// 判断是否通过群主认证
export const ifFunction = () => {
  return http.get(
    `${baseUrl}if-function&unionid=${window.localStorage.getItem('unionid')}`,
  );
};

//  判断是否通过群主认证
export const ifWithdrawal = () => {
  return http.get(
    `${baseUrl}if-withdrawal&unionid=${window.localStorage.getItem('unionid')}`,
  );
};
// 判断是否可以提现
export const nowIcon = () => {
  return http.get(
    `${baseUrl}now-icon&unionid=${window.localStorage.getItem('unionid')}`,
  );
};
// 报名页面提交报名接口
export function save(voteName: string, data: any) {
  const qsData = qs.stringify(data);
  return http.post(
    '/vote/' + voteName + '/controller.php?enews=group-save',
    qsData,
  );
}

//  最新5条分享记录
export const topNews = () => {
  return http.get(
    `${baseUrl}top-news&unionid=${window.localStorage.getItem('unionid')}`,
  );
};

//  推荐社群
export const recommend = () => {
  return http.get(
    `${baseUrl}recommend&unionid=${window.localStorage.getItem('unionid')}`,
  );
};

//  提现
export const withdrawalSave = () => {
  return http.get(
    `${baseUrl}withdrawal-save&unionid=${window.localStorage.getItem(
      'unionid',
    )}`,
  );
};

//  上传截图
export const pictureSave = (cover: any) => {
  const qsData = qs.stringify(cover);
  return http.post(`${baseUrl}picture-save`, qsData);
};

//  是否可申请认证
export const ifGroup = () => {
  return http.get(
    `${baseUrl}if-group&unionid=${window.localStorage.getItem('unionid')}`,
  );
};
